import { store } from '../app/store';

const apigClientFactory = require('aws-api-gateway-client').default;

let apiId = '';
export const setApiGatewayId = (config: any) => {
    apiId = config.api_gateway_config.api_id;
};

export const getApiGatewayUrl = () => `https://${apiId}.execute-api.us-east-1.amazonaws.com/prod`;

export default (
    deviceId: string,
    vin: string,
    forceStrictValidation: boolean,
    setResult: (success: boolean, r: any) => void,
    isComponentWorkflow: boolean = false,
) => {
    // extract endpoint from config
    const client = apigClientFactory.newClient({
        invokeUrl: getApiGatewayUrl(),
        retries: 3,
    });

    client
        .invokeApi(
            {},
            '/device_status_info',
            'GET',
            {
                queryParams: {
                    deviceId: deviceId,
                    vin: vin,
                    strictValidation: forceStrictValidation,
                    isComponentWorkflow: isComponentWorkflow,
                },
                headers: {
                    Authorization: store.getState().userData.userInfo!.jwt,
                },
            },
            null,
        )
        .then((response: any) => {
            const unescapedData = response.data.replace(/\\"/g, '"');
            const parsedData = JSON.parse(unescapedData);
            setResult(true, parsedData);
        })
        .catch((response: any) => {
            setResult(false, response);
        });
};
